
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandH as ObiOwnShipNoCommandHElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-h.js';
 
 
 

 
 export const ObiOwnShipNoCommandH = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-h',
   elementClass: ObiOwnShipNoCommandHElement,
   events: {
     
   }
  });
 
 